export const ACCOUNT_TYPE_STORAGE_KEY = 'accountType';
